/* NBT: vertaalt een tekst via window.NB_T. Zonder tabel (Japans) komt het origineel terug.
   Staat de hele tekst er niet in, dan worden bekende woorden binnenin vervangen (HTML-fragmenten). */
function NBT(s) {
  var T = window.NB_T;
  if (!T || typeof s !== 'string') return s;
  if (Object.prototype.hasOwnProperty.call(T, s)) return T[s];
  var k = window.NB_TK || (window.NB_TK = Object.keys(T).sort(function (a, b) { return b.length - a.length; }));
  var uit = s;
  for (var i = 0; i < k.length; i++) {
    if (uit.indexOf(k[i]) !== -1) uit = uit.split(k[i]).join(T[k[i]]);
  }
  return uit;
}
/* NOBIASHI: gedrag van header, megamenu, mobiel menu, shoe finder en review-slider (Hike-opbouw). */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.getElementById('nb-header-root');
    if (root) initHeader(root);
    document.querySelectorAll('[data-nb-finder]').forEach(initFinder);
    document.querySelectorAll('[data-nb-slider]').forEach(initSlider);
    initCart();
  });

  function initCart() {
    document.querySelectorAll('[data-nb-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var drawer = window.NBCart || document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function' && !/\/cart$/.test(window.location.pathname)) {
          e.preventDefault();
          var mobileDrawer = document.querySelector('[data-nb-drawer]');
          if (mobileDrawer) { mobileDrawer.classList.add('tw-hidden'); document.documentElement.style.overflow = ''; }
          drawer.open();
        }
      });
    });
    function refresh() {
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('[data-nb-cart-count]').forEach(function (el) {
            el.textContent = c.item_count;
            el.classList.toggle('tw-hidden', !c.item_count);
          });
        })
        .catch(function () {});
    }
    document.addEventListener('cart:update', refresh);
    document.addEventListener('cart:lines-update', refresh);
  }

  function initHeader(root) {
    var header = root.querySelector('[data-nb-header]');

    // megamenu (desktop, hover + toetsenbord)
    var closeTimer = null;
    function panels() { return root.querySelectorAll('[data-nb-mega-panel]'); }
    function show(id) {
      clearTimeout(closeTimer);
      panels().forEach(function (p) {
        var open = p.getAttribute('data-nb-mega-panel') === id;
        p.classList.toggle('opacity-0', !open);
        p.classList.toggle('-translate-y-2', !open);
        p.classList.toggle('pointer-events-none', !open);
        p.setAttribute('aria-hidden', open ? 'false' : 'true');
      });
      root.querySelectorAll('[data-nb-mega-trigger]').forEach(function (t) {
        var btn = t.querySelector('[aria-expanded]');
        var open = t.getAttribute('data-nb-mega-trigger') === id;
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var chev = t.querySelector('svg');
        if (chev) chev.style.transform = open ? 'rotate(180deg)' : '';
      });
    }
    function hideSoon() { closeTimer = setTimeout(function () { show(null); }, 120); }
    root.querySelectorAll('[data-nb-mega-trigger]').forEach(function (t) {
      var id = t.getAttribute('data-nb-mega-trigger');
      t.addEventListener('mouseenter', function () { show(id); });
      t.addEventListener('mouseleave', hideSoon);
      var btn = t.querySelector('[role="button"]');
      if (btn) btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(btn.getAttribute('aria-expanded') === 'true' ? null : id); }
        if (e.key === 'Escape') show(null);
      });
    });
    panels().forEach(function (p) {
      p.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      p.addEventListener('mouseleave', hideSoon);
    });
    root.querySelectorAll('nav [href]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { if (!a.closest('[data-nb-mega-trigger]') || !a.closest('[data-nb-mega-trigger]').querySelector('[role="button"]')) show(null); });
    });

    // help-dropdown in aankondigingsbalk
    root.querySelectorAll('[data-nb-dropdown]').forEach(function (d) {
      var btn = d.querySelector('[data-nb-dropdown-toggle]');
      var panel = d.querySelector('[data-nb-dropdown-panel]');
      function set(open) { panel.classList.toggle('tw-hidden', !open); btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      var timer = null;  // korte vertraging: muis mag van de knop naar het paneel bewegen zonder dat het dichtklapt
      d.addEventListener('mouseenter', function () { clearTimeout(timer); set(true); });
      d.addEventListener('mouseleave', function () { timer = setTimeout(function () { set(false); }, 300); });
      document.addEventListener('click', function (e) { if (!d.contains(e.target)) set(false); });
      btn.addEventListener('click', function () { set(panel.classList.contains('tw-hidden')); });
    });

    // mobiel zoeken
    var mSearch = root.querySelector('[data-nb-search-mobile]');
    root.querySelectorAll('[data-nb-search-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        mSearch.classList.toggle('tw-hidden');
        if (!mSearch.classList.contains('tw-hidden')) mSearch.querySelector('input').focus();
      });
    });

    // mobiel menu
    var drawer = root.querySelector('[data-nb-drawer]');
    function openDrawer() { drawer.classList.remove('tw-hidden'); document.documentElement.style.overflow = 'hidden'; }
    function closeDrawer() {
      drawer.classList.add('tw-hidden');
      document.documentElement.style.overflow = '';
      drawer.querySelectorAll('[data-nb-sub]').forEach(function (s) { s.classList.add('tw-hidden'); });
    }
    root.querySelectorAll('[data-nb-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
    drawer.querySelectorAll('[data-nb-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    drawer.querySelectorAll('[data-nb-sub-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sub = drawer.querySelector('[data-nb-sub="' + b.getAttribute('data-nb-sub-open') + '"]');
        if (sub) sub.classList.remove('tw-hidden');
      });
    });
    drawer.querySelectorAll('[data-nb-sub-close]').forEach(function (b) {
      b.addEventListener('click', function () { b.closest('[data-nb-sub]').classList.add('tw-hidden'); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); show(null); } });

    // hoogte van de header als CSS-variabele (voor secties die er rekening mee houden)
    if (header && 'ResizeObserver' in window) {
      new ResizeObserver(function () {
        document.documentElement.style.setProperty('--nb-header-height', header.offsetHeight + 'px');
      }).observe(header);
    }
  }

  function initFinder(form) {
    // Hike: alle gekozen opties samen filteren (EN). Hier via tags: /collections/all/tag1+tag2
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var tags = [];
      form.querySelectorAll('select[data-nb-finder-select]').forEach(function (sel) {
        if (sel.value) tags.push(encodeURIComponent(sel.value));
      });
      var base = (form.getAttribute('action') || '/collections/all').replace(/\/$/, '');
      window.location.href = tags.length ? base + '/' + tags.join('+') : base;
    });
  }

  function initSlider(root) {
    var track = root.querySelector('[data-nb-slider-track]');
    var bar = root.querySelector('[data-nb-slider-dots]');
    if (!track || !bar) return;
    var fill = bar.firstElementChild;
    var slides = track.children;
    /* Hike (Swiper progressbar): scaleX = (actieve stap + 1) / aantal stappen */
    function update() {
      if (!fill || !slides.length) return;
      var w = slides[0].getBoundingClientRect().width + 30;
      var perView = Math.max(1, Math.round((track.clientWidth + 30) / w));
      var steps = Math.max(1, slides.length - perView + 1);
      var max = track.scrollWidth - track.clientWidth;
      var idx = max > 0 ? Math.round((track.scrollLeft / max) * (steps - 1)) : 0;
      fill.style.transform = 'scaleX(' + ((idx + 1) / steps) + ')';
    }
    update();
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
  }
})();
